"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get down () {
        return down;
    },
    get up () {
        return up;
    }
});
const _globals = require("~/utils/globals");
const up = async (knex)=>{
    await knex.schema.createTable(_globals.MetaTable.DATA_REFLECTION, (table)=>{
        table.string('id', 20).primary();
        table.string('fk_workspace_id', 20);
        table.string('username', 255);
        table.string('password', 255);
        table.string('database', 255);
        table.timestamps(true, true);
    });
};
const down = async (knex)=>{
    await knex.schema.dropTable(_globals.MetaTable.DATA_REFLECTION);
};
